"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../utils/core"));

var _jquery = _interopRequireDefault(require("../utils/jquery.webf"));

var _jquery2 = _interopRequireDefault(require("jquery"));

/**
 * options:
 *  - onLoaded:         (function(image, ev))
 *  - onAllLoaded:      (function(image, ev))
 */
(0, _jquery["default"])('imageloader', {
  options: {
    onLoaded: _core["default"].noop,
    onAllLoaded: _core["default"].noop
  },
  _create: function _create() {
    var self = this;
    var $imgs = this.e[0].tagName.toLowerCase() == 'img' ? this.e : this.e.find('img');
    var loaded = 0;
    var nbImgs = $imgs.length;

    if (!nbImgs) {
      this._call(this.option('onLoaded'));

      this._call(this.option('onAllLoaded'));
    }

    $imgs.each(function (i, img) {
      var $img = (0, _jquery2["default"])(img);
      var image = new Image();
      image.src = (0, _jquery2["default"])(img).prop('src');

      var onLoad = function onLoad(ev) {
        loaded++;

        self._call(self.option('onLoaded'), $img, this, ev);

        if (loaded == nbImgs) {
          self._call(self.option('onAllLoaded'), $img, this, ev);

          self.destroy();
        }
      };

      image.onload = onLoad;
      image.onerror = onLoad;
    });
  }
});